export const NOTIFICATION_CENTER_TABS = {
	Upcoming: "upcoming",
	Recent: "recent",
} as const;

export type NotificationCenterTab =
	(typeof NOTIFICATION_CENTER_TABS)[keyof typeof NOTIFICATION_CENTER_TABS];

export const DEFAULT_NOTIFICATION_CENTER_TAB: NotificationCenterTab =
	NOTIFICATION_CENTER_TABS.Upcoming;

export const NOTIFICATION_CENTER_TAB_ORDER: NotificationCenterTab[] = [
	NOTIFICATION_CENTER_TABS.Upcoming,
	NOTIFICATION_CENTER_TABS.Recent,
];

export const NOTIFICATION_CENTER_TAB_QUERY_PARAM = "tab";

export const isNotificationCenterTab = (
	value: string | null,
): value is NotificationCenterTab =>
	value === NOTIFICATION_CENTER_TABS.Upcoming ||
	value === NOTIFICATION_CENTER_TABS.Recent;
